import { api } from '@/config/api';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface EmailInboxAddress {
  _id: string;
  addressUid: string;
  companyUid: string;
  emailAddress: string;
  isActive: boolean;
  label?: string;
  defaultBotFlowUid?: string;
  lastReceivedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEmailInboxPayload {
  emailAddress: string;
  label?: string;
  defaultBotFlowUid?: string;
}

export interface UpdateEmailInboxPayload {
  isActive?: boolean;
  label?: string;
  defaultBotFlowUid?: string;
}

// ─── Service ─────────────────────────────────────────────────────────────────

export const emailInboxesService = {
  list: async (): Promise<EmailInboxAddress[]> =>
    (await api.get('/slighter_crm/settings/email-inboxes')).data,

  create: async (payload: CreateEmailInboxPayload): Promise<EmailInboxAddress> =>
    (await api.post('/slighter_crm/settings/email-inboxes', payload)).data,

  update: async (
    addressUid: string,
    payload: UpdateEmailInboxPayload,
  ): Promise<EmailInboxAddress> =>
    (await api.patch(`/slighter_crm/settings/email-inboxes/${addressUid}`, payload)).data,

  remove: async (addressUid: string): Promise<{ ok: boolean }> =>
    (await api.delete(`/slighter_crm/settings/email-inboxes/${addressUid}`)).data,

  /** Whether the platform accepts inbound email at all (provider + signing key configured). */
  status: async (): Promise<{ ready: boolean; provider: 'mailgun' | 'signed_json' | null }> =>
    (await api.get('/slighter_crm/settings/email-inboxes/status')).data,

  /** Returns the public webhook URL for displaying in the settings UI. */
  webhookUrl: (): string => {
    const base =
      process.env.REACT_APP_API_BASE?.replace('/api/v1', '') ?? 'https://your-host.com';
    return `${base}/api/v1/email-webhook`;
  },
};
